import { actionTypesEnum } from '../enum';

export const validarExoneracion = (state = null, action) => {

    if(action.type === actionTypesEnum.getExoneracion){
        return action.payload;
    }

    return state;
}